import React from 'react';
import { NavLink } from './NavLink';

export const NavListItemLink = props => (
  <li className="nav-item">
    <NavLink className="nav-link" {...props}>
      {props.children}
    </NavLink>
  </li>
);
